import { useMutation } from '@tanstack/react-query';

import { NotificationService } from '@fsd/shared/lib/notifications';

import { getPurchaseMissingProductCostDownload } from
    '@fsd/entities/purchase/api/getPurchaseMissingProductCostDownload/getPurchaseMissingProductCostDownload';

import type {
  MissingPurchasePriceAlert as MissingPurchasePriceAlertData,
} from '@fsd/entities/global-alert';

interface Props {
  alert: MissingPurchasePriceAlertData;
}

export const MissingPurchasePriceAlert = ({ alert }: Props) => {
  const { mutate: download, isPending } = useMutation({
    mutationFn: getPurchaseMissingProductCostDownload,

    onSuccess: () => {
      NotificationService.success({
        title: 'Успех!',
        message: 'Вы успешно скачали выгрузку товаров без себестоимости!',
      });
    },

    onError: () => {
      NotificationService.error({
        title: 'Ошибка!',
        message: 'Ошибка при скачивании выгрузки товаров без себестоимости!',
      });
    },
  });

  return (
    <>
      Внимание! Отчёт о финансовых результатах и Баланс недостоверны!
      С {alert.first_date} в отчёте есть товары без прикреплённой
      себестоимости ({alert.total_count} шт.). Срочно проведите
      отгрузку недостающих товаров.{' '}

      <a
        onClick={() => download()}
        style={{
          textDecoration: 'underline',
          cursor: 'pointer',
          background: 'none',
          border: 'none',
          padding: 0,
          font: 'inherit',
        }}
      >
        Скачать список
      </a>
    </>
  );
};